import { Upload, FolderOpen } from 'lucide-react'
import { cn } from '@/lib/utils'

interface DropZoneOverlayProps {
  folderName: string | null
  disabled?: boolean
  className?: string
}

export function DropZoneOverlay({ folderName, disabled, className }: DropZoneOverlayProps) {
  return (
    <div
      className={cn(
        'absolute inset-0 z-10 flex flex-col items-center justify-center',
        'border-2 border-dashed',
        'pointer-events-none transition-colors duration-150',
        disabled
          ? 'border-muted-foreground/50 bg-muted/50'
          : 'border-primary bg-primary/5',
        className
      )}
    >
      <div className="flex flex-col items-center rounded-xl bg-card p-4 shadow-sm">
        {disabled ? (
          <>
            <FolderOpen className="mb-2 h-8 w-8 text-muted-foreground" />
            <p className="text-sm font-medium text-muted-foreground">
              Select a folder to upload files
            </p>
          </>
        ) : (
          <>
            <Upload className="mb-2 h-8 w-8 text-primary" />
            <p className="text-sm font-medium text-foreground">Drop files to upload</p>
            <p className="text-meta">to "{folderName}"</p>
          </>
        )}
      </div>
    </div>
  )
}
